import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';

export default function PackagesPortal({ data, onClose }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => (document.body.style.overflow = '');
  }, []);

  return createPortal(
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm z-[9999] flex items-center justify-center px-4 sm:px-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl mx-auto p-6 relative max-h-[90vh] overflow-y-auto"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-blue-600 hover:text-red-500 font-bold text-xl"
          >
            ✕
          </button>

          <h3 className="text-2xl font-bold text-blue-900 mb-4">
            {data.title} – What's Included
          </h3>
          <ul className="text-gray-800 space-y-4 text-sm">
            {data.features.map((item, idx) => (
              <li key={idx} className="flex items-start gap-3">
                <span className="text-blue-500 mt-1">{item.icon}</span>
                <div>
                  <p className="font-semibold">{item.text}</p>
                  <p className="text-gray-600 text-xs">{item.detail}</p>
                </div>
              </li>
            ))}
          </ul>

          <p className="mt-6 text-center text-blue-700 font-medium">{data.detail}</p>
          <p className="text-sm italic text-center text-gray-500 mt-1">{data.note}</p>
        </motion.div>
      </motion.div>
    </AnimatePresence>,
    document.body
  );
}
